import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import FooterCSS from './footer.module.css'

import LogoColibri from '../../assets/colibri-light.svg'
import { initService } from '../../services/init.service'
import { getSocialIcon } from '../../utils/functions/socials'

const Footer = () => {
  // Las redes se administran desde el panel (/admin/contenido) y salen del
  // endpoint público de init. Hasta que responda, o si falla, el footer se
  // dibuja igual pero sin la fila de iconos.
  const [socials, setSocials] = useState([])

  useEffect(() => {
    const fetchSocials = async () => {
      try {
        const response = await initService.getSocials()

        if (Array.isArray(response.data)) {
          setSocials(response.data)
        }
      } catch (error) {
        console.error('No se pudieron cargar las redes sociales', error)
      }
    }

    fetchSocials()
  }, [])

  return (
    <footer className={FooterCSS.footer}>
      <img
        className={`animate__animated animate__fadeIn animate__delay-01s`}
        src={LogoColibri}
        alt=''
      />
      <div className={FooterCSS.footerInfo}>
        <p className={`animate__animated animate__fadeIn animate__delay-01s`}>
          Copyright © 2026 Colibrí Premium Service
        </p>
        {socials.length > 0 && (
          <div className={FooterCSS.socials}>
            {socials.map((social, key) => (
              <a
                key={social.id}
                href={social.url}
                target='_blank'
                rel='noreferrer'
                title={social.nombre}
                className={`${FooterCSS.social} animate__animated animate__fadeIn animate__delay-0${Math.min(key + 1, 3)}s`}
              >
                <img src={getSocialIcon(social.icono)} alt={social.nombre} />
              </a>
            ))}
          </div>
        )}
        <div
          className={`${FooterCSS.miniMenu} animate__animated animate__fadeIn animate__delay-04s`}
        >
          <Link to='/servicios'>Términos y condiciones</Link>
          <Link to='/servicios'>Políticas de privacidad</Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
